import { render } from "./Identifiers.vue?vue&type=template&id=719f14e4"
import script from "./Identifiers.vue?vue&type=script&lang=js"
export * from "./Identifiers.vue?vue&type=script&lang=js"

import "./Identifiers.vue?vue&type=style&index=0&id=719f14e4&lang=scss"

import exportComponent from "/home/admin/armada-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__